import React from "react";
import "./PopularTodayItem.css";
// import { Link } from "react-router-dom";

function PopularTodayItem({ article, num }) {
  const category = article.category
    ? article.category.slug
    : article.links.detail.split("/")[0];
  return (
    <>
      <div className="popular-today__item">
        <div className="popular-today__item-num">{num}</div>
        <a href={`/${category}/${article.slug}/`}
          className="popular-today__item-ttl"
        >
          {article.title}
        </a>
      </div>
    </>
  );
}

export default PopularTodayItem;
